<template>
  <div>
    <div class="container">
      <div class="row justify-content-center p-5">
        <div class="col-xl-10 col-lg-12 col-md-9 p-5">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <div class="row p-5 m-5" v-if="error" style="height:500px">
                <div class="col-md-12 text-center">
                  <sweetalert-icon :icon="errorType" />
                </div>
                <div class="col-md-12 text-center">
                  <h3 class="text-center">{{ errormessage }}</h3>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">Reset Password!</h1>
                    </div>
                    <form class="user" @submit.prevent="sendResetAction">
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control form-control-user"
                          v-model="resetEmail"
                          aria-describedby="emailHelp"
                          placeholder="Enter Email Address..."
                        />
                      </div>
                      <button
                        class="btn btn-primary btn-user btn-block"
                        type="submit"
                      >
                        {{ resetButtonText }}
                      </button>
                      <hr />
                    </form>
                    <hr />
                    <div class="text-center">
                      <router-link to="/vendor" class="small">
                        Go back to login?</router-link
                      >
                    </div>
                    <div class="text-center">
                      <router-link to="/vendor/register" class="small">
                        Create an Vendor Account!
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendResetLink } from "@/modules/auth";
import constants from "@/modules/constants";
export default {
  data() {
    return {
      error: false,
      resetEmail: "",
      errorType: "success",
      errormessage: "",
      resetButtonText: constants.actions.send_reset
    };
  },
  methods: {
    sendResetAction() {
      if (this.resetButtonText === constants.info.sent) return;
      if (!this.resetEmail) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (this.resetEmail.trim().length === 0) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      this.resetButtonText = constants.info.sending_reset;
      sendResetLink(this.resetEmail)
        .then(() => {
          this.$root.toast(constants.info.sent_reset);
        })
        .catch(error => {
          this.$root.toast(constants.errors[error.code]);
        })
        .finally(() => {
          this.resetButtonText = constants.actions.send_reset;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
